/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PianoAssenzeGiornoDTO
 */
export interface PianoAssenzeGiornoDTO {
    /**
     * 
     * @type {string}
     * @memberof PianoAssenzeGiornoDTO
     */
    dataTemp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PianoAssenzeGiornoDTO
     */
    data?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PianoAssenzeGiornoDTO
     */
    testo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PianoAssenzeGiornoDTO
     */
    colore?: string | null;
}

/**
 * Check if a given object implements the PianoAssenzeGiornoDTO interface.
 */
export function instanceOfPianoAssenzeGiornoDTO(value: object): value is PianoAssenzeGiornoDTO {
    return true;
}

export function PianoAssenzeGiornoDTOFromJSON(json: any): PianoAssenzeGiornoDTO {
    return PianoAssenzeGiornoDTOFromJSONTyped(json, false);
}

export function PianoAssenzeGiornoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PianoAssenzeGiornoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'dataTemp': json['dataTemp'] == null ? undefined : json['dataTemp'],
        'data': json['data'] == null ? undefined : json['data'],
        'testo': json['testo'] == null ? undefined : json['testo'],
        'colore': json['colore'] == null ? undefined : json['colore'],
    };
}

export function PianoAssenzeGiornoDTOToJSON(json: any): PianoAssenzeGiornoDTO {
    return PianoAssenzeGiornoDTOToJSONTyped(json, false);
}

export function PianoAssenzeGiornoDTOToJSONTyped(value?: PianoAssenzeGiornoDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dataTemp': value['dataTemp'],
        'data': value['data'],
        'testo': value['testo'],
        'colore': value['colore'],
    };
}

